/**
 * Measured geometry of the official Form SS-4 (Rev. December 2025), extracted
 * from a 288dpi render of fss4.pdf. Units are PDF points, y from the top of
 * the page.
 *
 * GENERATED — do not hand-edit. Re-derive if the form revision changes. The
 * replica renders these arrays directly, so its rule structure is the
 * official's rather than an approximation of it.
 *
 * Page 1 is US Letter (611.976 x 791.968pt). Page 2's own MediaBox is
 * 612 x 828pt, but every mark on it sits within the first 700pt, so the
 * replica renders it on a Letter sheet with the same top-anchored coordinates.
 *
 * Note there is NO rule across the top of the masthead — the three masthead
 * columns are divided vertically from y=36 with no horizontal rule closing
 * them. The first full-width rule is the masthead's bottom at y=84.
 */

/** Horizontal rules on page 1: [y, x0, x1] */
export const H_RULES_P1: readonly (readonly number[])[] = [
  [48, 438.75, 576.0],
  [84, 36.0, 576.0],
  [108, 50.25, 576.0],
  [132, 50.25, 576.0],
  [156, 50.25, 576.0],
  [180, 50.25, 576.0],
  [204, 50.25, 576.0],
  [228, 36.0, 576.0],
  [252, 36.0, 576.0],
  [264, 36.0, 576.0],
  [288, 158.25, 259.5],
  [288, 446.25, 576.0],
  [300, 439.0, 576.0],
  [312, 237.25, 324.25],
  [312, 431.75, 576.0],
  [348, 215.75, 324.25],
  [360, 36.0, 576.0],
  [384, 36.0, 576.0],
  [396, 424.5, 576.0],
  [408, 208.5, 266.75],
  [408, 467.75, 576.0],
  [420, 57.25, 266.75],
  [432, 403.0, 576.0],
  [444, 431.75, 576.0],
  [456, 36.0, 576.0],
  [480, 36.0, 576.0],
  [540, 36.0, 576.0],
  [564, 36.0, 576.0],
  [600, 36.0, 576.0],
  [624, 36.0, 576.0],
  [648, 36.0, 576.0],
  [660, 86.0, 576.0],
  [684, 86.0, 576.0],
  [708, 36.0, 576.0],
  [732, 36.0, 576.0],
  [755.5, 36.0, 576.0],
];

/** Vertical rules on page 1: [x, y0, y1] */
export const V_RULES_P1: readonly (readonly number[])[] = [
  [50.25, 84, 228],
  [86.0, 648, 709],
  [114.75, 36, 85],
  [143.75, 516, 540],
  [230.25, 516, 540],
  [273.25, 360, 384],
  [295.0, 108, 180],
  [331.0, 204, 252],
  [331.0, 456, 540],
  [403.0, 360, 384],
  [431.75, 660, 757],
  [438.75, 36, 85],
];

/** Horizontal rules on page 2: [y, x0, x1] */
export const H_RULES_P2: readonly (readonly number[])[] = [
  [48, 36.0, 576.0],
  [72, 36.0, 576.0],
  [120, 36.0, 576.0],
  [132, 36.0, 576.0],
  [156, 36.0, 576.0],
  [180, 36.0, 576.0],
  [204, 36.0, 576.0],
  [240, 36.0, 576.0],
  [252, 36.0, 576.0],
  [276, 36.0, 576.0],
  [300, 36.0, 576.0],
  [336, 36.0, 576.0],
  [360, 36.0, 576.0],
  [408, 36.0, 576.0],
  [432, 36.0, 576.0],
  [504, 36.0, 576.0],
  [528, 36.0, 576.0],
  [694, 36.0, 576.0],
];

/**
 * Vertical rules on page 2: [x, y0, y1]. The reference table has no outer
 * left/right border — only these two internal column splits.
 */
export const V_RULES_P2: readonly (readonly number[])[] = [
  [151.0, 120, 528],
  [359.75, 120, 528],
];

/** Every checkbox on the form is 8 x 8pt. */
export const CHECKBOX_PT = 8;

/** Checkbox origins on page 1: [x, y] of the box's top-left corner. */
export const CHECKBOXES: readonly (readonly number[])[] = [
  [255.0, 241.2],
  [298.25, 241.2],
  [492.5, 253.8],
  [543.0, 253.8],
  [60.5, 277.8],
  [334.25, 277.8],
  [60.5, 289.8],
  [334.25, 289.8],
  [60.5, 301.8],
  [334.25, 301.8],
  [60.5, 313.8],
  [334.25, 313.8],
  [442.25, 313.8],
  [60.5, 325.8],
  [334.25, 325.8],
  [442.25, 325.8],
  [60.5, 337.8],
  [334.25, 337.8],
  [442.25, 337.8],
  [60.5, 349.8],
  [276.5, 386.8],
  [60.5, 397.8],
  [276.5, 398.8],
  [276.5, 410.8],
  [60.5, 422.8],
  [276.5, 422.8],
  [60.5, 434.8],
  [276.5, 434.8],
  [60.5, 445.8],
  [563.25, 529.8],
  [319.75, 565.8],
  [449.25, 565.8],
  [60.5, 577.8],
  [125.25, 577.8],
  [204.5, 577.8],
  [319.75, 577.8],
  [449.25, 577.8],
  [535.75, 577.8],
  [60.5, 589.8],
  [125.25, 589.8],
  [204.5, 589.8],
  [319.75, 589.8],
  [355.75, 625.8],
  [399.0, 625.8],
];
